<template>
<div>
  <div v-if="currentJobseeker">
    <div v-for="(item, index) in items" :key="index" >
      <div v-if="item.description !== ''">
        <item :title="item.title" :description="item.description" :is-compact="true">
        </item>
        <divider />
      </div>
    </div>
  </div>
  <item :title="this.$t('jobs.resume')">
  <p v-if="resumeUrl === 'attached'">{{this.$t('jobs.attached')}}</p>
  <p v-else>{{this.$t('jobs.unattached')}}</p>
  </item>
</div>
</template>

<script>
import { mapState } from 'vuex'
import Item from '@/components/general/sidebar-section'
import Divider from '@/components/general/divider'
import _ from 'lodash'

export default {
  components: { Item, Divider },
  props: {
    isOther: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('jobseekers', {
      currentJobseeker: 'currentJobseeker'
    }),
    salary () {
      return this.currentJobseeker.salary
    },
    noticePeriodInDays () {
      return this.currentJobseeker.noticePeriod
    },
    noticePeriodText () {
      return this.noticePeriodInDays ? `${this.noticePeriodInDays} days` : ''
    },
    items () {
      const salaryText = this.salary
        ? `$${this.salary.toLocaleString()} (min)` : ''
      const locations = this.currentJobseeker.locations
      if (this.currentJobseeker.isRemoteAvailable) {
        locations.unshift('Remote')
      }
      return [{
        title: this.$t('jobs.roles'),
        description: this.currentJobseeker.roles.join(', ')
      }, {
        title: this.$t('jobs.salary'),
        description: salaryText
      }, {
        title: this.$t('jobs.locations'),
        description: locations.join(', ')
      }, {
        title: this.$t('jobs.contractTypes'),
        description: this.currentJobseeker.contracts.map(_.capitalize).join(', ')
      }, {
        title: this.$t('jobs.noticePeriod'),
        description: this.noticePeriodText
      }]
    },
    resumeUrl () {
      return this.currentJobseeker.resumeUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.item h6.heading {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/preferences-other.vue